import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useEffect, useId, useMemo } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { TabsContext } from '../TabsContext/index.esm.js';
import { TabsList } from '../TabsList/index.esm.js';
import { TabsPanel } from '../TabsPanel/index.esm.js';
import { TabsTab } from '../TabsTab/index.esm.js';
import '../utils.esm.js';
import '@skatteetaten/ds-icons';

const getTabsVariantDefault = ()=>'standard';

const Tabs = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, defaultValue, hasBorder, isMultiline, value, variant = getTabsVariantDefault(), onChange, children }, ref)=>{
    const [activeTab, setActiveTab] = useState(value ?? defaultValue);
    useEffect(()=>{
        if (!value) return;
        setActiveTab(value);
    }, [
        value
    ]);
    const [index, setIndex] = useState(0);
    if (activeTab === undefined) {
        throw new Error(`prop 'defaultValue' eller 'value' må ha en satt verdi`);
    }
    const baseId = useId();
    const contextValue = useMemo(()=>({
            activeTab,
            baseId,
            hasBorder,
            setInternalActiveTab: (value)=>{
                setActiveTab(value);
                if (value) onChange?.(value);
            },
            variant,
            isMultiline,
            index,
            setIndex
        }), [
        activeTab,
        baseId,
        hasBorder,
        variant,
        isMultiline,
        index,
        onChange
    ]);
    return /*#__PURE__*/ jsx("div", {
        ref: ref,
        id: id,
        className: className,
        lang: lang,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ jsx(TabsContext.Provider, {
            value: contextValue,
            children: children
        })
    });
});
Tabs.displayName = 'Tabs';
Tabs.List = TabsList;
Tabs.List.displayName = 'Tabs.List';
Tabs.Panel = TabsPanel;
Tabs.Panel.displayName = 'Tabs.Panel';
Tabs.Tab = TabsTab;
Tabs.Tab.displayName = 'Tabs.Tab';

export { Tabs, getTabsVariantDefault };
